<p>shipping-policy works!</p>
